module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/survive-f46cfeb4932e664bf45f090b1d56b7a8.svg";